import { ReportDataResponse, ReportResult } from "@/api/auth/disconnectReport";
import { roundNumber } from "@/utils/round";
import mapKnownValues from "@/utils/mapKnownValues";
import sortBy from "lodash/sortBy";

export class DisconnectMetricResult {
  metricValue = 0;
  end = new Date();
  start = new Date();

  constructor(params: Partial<DisconnectMetricResult>) {
    mapKnownValues(this, params);
  }
}

export class DisconnectMetricsValues extends DisconnectMetricResult {
  constructor(params: Partial<DisconnectMetricResult>) {
    super(params);
    this.metricValue = roundNumber(params.metricValue);
  }
}

export default class DisconnectMetrics {
  data!: DisconnectMetricResult[];

  constructor(params: Partial<DisconnectMetrics>) {
    mapKnownValues(this, params);
    this.data = sortBy(params.data || [], d => d.end).map(_data => new DisconnectMetricsValues(_data));
  }

  static fromAPI(response: ReportDataResponse) {
    function formatAPIResultData(_data: ReportResult) {
      return new DisconnectMetricResult({
        metricValue: _data.metricValue,
        start: _data.start ? new Date(_data.start) : undefined,
        end: _data.end ? new Date(_data.end) : undefined
      });
    }
    return new DisconnectMetrics({
      data: (response.data || []).map(formatAPIResultData)
    });
  }
}
